import React from "react";
import { getDeviceIcon, getDeviceDisplayName } from "../../utils";

const OtherSessions = ({ otherSessions }) => {
  return (
    <div className="other-sessions-container">
      <div className="session-header">
        Other Sessions ({otherSessions.length})
      </div>
      <div className="other-sessions-list">
        {otherSessions?.map((session) => (
          <div key={session.sessionId} className="session-item">
            <div className="session-icon-container other">
              {getDeviceIcon(session.os, session.deviceType)}
            </div>
            <div className="session-details">
              <div className="session-device-name">
                {getDeviceDisplayName(
                  session.browser,
                  session.os,
                  session.deviceType
                )}
              </div>
              <div className="session-location">
                {session?.location?.city || "Lahore"}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OtherSessions;
